// @ts-expect-error image
import twitterImageUrl from 'bender-url!../../img/screenshot-twitter.png';
// @ts-expect-error image
import openGraphImageUrl from 'bender-url!../../img/screenshot-og.png';
import I18n from 'I18n';
import getLang from 'I18n/utils/getLang';
import unescapedText from 'I18n/utils/unescapedText';
import CanonicalLink from 'marketplace-ui-common/components/elements/CanonicalLink';
import HrefLangLink from 'marketplace-ui-common/components/elements/HrefLangLink';
import MetaDescription from 'marketplace-ui-common/components/elements/MetaDescription';
import MetaOpenGraph from 'marketplace-ui-common/components/elements/MetaOpenGraph';
import MetaTwitter from 'marketplace-ui-common/components/elements/MetaTwitter';
import DocumentHead from 'marketplace-ui-common/components/portals/DocumentHead';
import PrerenderReady from 'marketplace-ui-common/components/prerender/PrerenderReady';
import { PUBLIC_LANGUAGES } from 'marketplace-ui-common/constants/Languages';
import { Fragment, useCallback, useEffect, useMemo } from 'react';
import { NavMarker } from 'react-rhumb';
import AppMarketplaceSection from '../components/AppMarketplaceSection';
import AssetMarketplaceSection from '../components/AssetMarketplaceSection';
import CmsFreeSection from '../components/CmsFreeSection';
import HeaderSection from '../components/HeaderSection';
import MarketplaceCardsSection from '../components/MarketplaceCardsSection';
import ProviderSignupSection from '../components/ProviderSignupSection';
import SolutionsDirectorySection from '../components/SolutionsDirectorySection';
import { getFullPublicUrl } from '../utils/urls';
import usageTracker from '../utils/usageTracker';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function Home() {
  const lang = getLang();
  const canonicalUrl = getFullPublicUrl(lang);
  const metaDescription = unescapedText('marketplaceUnified.metaDescription');
  const renderedHrefLangLinks = useMemo(() => {
    return PUBLIC_LANGUAGES.map(_lang => /*#__PURE__*/_jsx(HrefLangLink, {
      href: getFullPublicUrl(_lang),
      lang: _lang,
      "x-default": _lang === 'en'
    }, `href-lang-${_lang === 'en' ? 'default' : _lang}`));
  }, []);
  const trackInteraction = useCallback((action, eventProps = {}) => {
    usageTracker.track('interaction', Object.assign({
      screen: 'homepage',
      action
    }, eventProps));
  }, []);
  useEffect(() => {
    usageTracker.track('pageView', {
      screen: 'homepage'
    });
  }, []);
  useEffect(() => {
    document.title = I18n.text('marketplaceUnified.htmlTitle');
  }, []);
  return /*#__PURE__*/_jsxs(NavMarker, {
    name: "INDEX_LOAD",
    children: [/*#__PURE__*/_jsx(DocumentHead, {
      children: /*#__PURE__*/_jsxs(Fragment, {
        children: [/*#__PURE__*/_jsx(MetaDescription, {
          content: metaDescription
        }), /*#__PURE__*/_jsx(MetaTwitter, {
          name: "card"
        }), /*#__PURE__*/_jsx(MetaTwitter, {
          name: "site"
        }), /*#__PURE__*/_jsx(MetaTwitter, {
          name: "image",
          content: twitterImageUrl
        }), /*#__PURE__*/_jsx(MetaOpenGraph, {
          property: "type"
        }), /*#__PURE__*/_jsx(MetaOpenGraph, {
          property: "url",
          content: canonicalUrl
        }), /*#__PURE__*/_jsx(MetaOpenGraph, {
          property: "description",
          content: metaDescription
        }), /*#__PURE__*/_jsx(MetaOpenGraph, {
          property: "image",
          content: openGraphImageUrl
        }), /*#__PURE__*/_jsx(CanonicalLink, {
          href: canonicalUrl
        }), renderedHrefLangLinks, /*#__PURE__*/_jsx(PrerenderReady, {})]
      })
    }), /*#__PURE__*/_jsx(HeaderSection, {}), /*#__PURE__*/_jsxs("main", {
      children: [/*#__PURE__*/_jsx(MarketplaceCardsSection, {
        onTrackInteraction: trackInteraction
      }), /*#__PURE__*/_jsx(CmsFreeSection, {
        onTrackInteraction: trackInteraction
      }), /*#__PURE__*/_jsx(AssetMarketplaceSection, {
        onTrackInteraction: trackInteraction
      }), /*#__PURE__*/_jsx(AppMarketplaceSection, {
        onTrackInteraction: trackInteraction
      }), /*#__PURE__*/_jsx(SolutionsDirectorySection, {
        onTrackInteraction: trackInteraction
      }), /*#__PURE__*/_jsx(ProviderSignupSection, {
        onTrackInteraction: trackInteraction
      })]
    })]
  });
}